// Utility: apiBase.js
// Purpose: #46 — decide the API origin so the HttpOnly refresh cookie is FIRST-PARTY.
//
// The refresh cookie is issued with `samesite='lax'`
// (backend/auth/app/api/v1/endpoints/auth.py), and a Lax cookie is NEVER sent on a
// cross-site XHR — only on top-level navigation. Browsing the dev server on
// http://localhost:3000 while calling https://api.deetrade.net is cross-site, so
// POST /auth/refresh answered `401 {"detail":"Refresh token not provided"}` every
// single time. Login still worked (it returns the token in the body), so the session
// died ~45min later in an un-extendable "Session Expiring" modal, every session.
//
// app.deetrade.net and api.deetrade.net share the registrable domain deetrade.net, so
// they ARE same-site and must keep hitting the absolute URL exactly as before.
//
//! The SAME frontend container serves BOTH localhost:3000 and app.deetrade.net, so
//! this choice CANNOT be made with a build-time env var (REACT_APP_API_URL) without
//! breaking one of them — it has to be resolved per page-origin at runtime.

const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1", "0.0.0.0", "::1"]);

/*>>> Are we being served from a local dev origin? <<<*/
export function isLocalDevHost(hostname) {
  const host =
    hostname !== undefined
      ? hostname
      : typeof window !== "undefined"
      ? window?.location?.hostname
      : undefined;
  return LOCAL_HOSTS.has(host);
}

/**
 * Resolve the axios baseURL.
 * On a local dev origin -> a RELATIVE path, so the request is same-origin and gets
 * proxied by src/setupProxy.js (which also rewrites the Set-Cookie domain). Anywhere
 * else -> the configured absolute URL, unchanged.
 */
export function resolveApiBaseUrl(envUrl, fallback = "http://localhost:8000/api/v1") {
  if (isLocalDevHost()) return "/api/v1";
  return envUrl || fallback;
}
